<template>
  <div>
    <b-form v-if="value.httpAuth">
      <b-form-group id="exampleInputGroup1" label="Username" label-for="httpauth_username">
        <b-form-input id="httpauth_username" type="text" placeholder="Username" v-model="value.httpAuth.username" required @input="updateForm()">
        </b-form-input>
      </b-form-group>
      <b-form-group id="exampleInputGroup1" label="Password" label-for="wp_admin">
        <password-input idFor="wp_admin" v-model="value.httpAuth.password"></password-input>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
import PasswordInput from '../Common/PasswordInput';
export default {
  name: 'folderprotection',
  props: ['value'],
  components: {
    PasswordInput
  },
  mounted() {
    if (!this.value.httpAuth) {
      this.value.httpAuth = {};
      this.value.httpAuth = { username: '', password: '' };
    }
  },
  methods: {
    updateForm() {
      this.$emit('input', this.value);
    }
  }
};
</script>

<style>
</style>
